import router from '../router';

const state = () => {
  return {
    user: null,
    permissions: [],
    authProvider: localStorage.getItem('authProvider') || null,
    microsoftIdToken: localStorage.getItem('microsoftIdToken') || null,

  };
};

const getters = {
  isAuthenticated(state) {
    return state.user ? true : false;
  },
  fullName({ user }) {
    return user ? `${user.firstName} ${user.lastName}` : null;
  },
};

const mutations = {
  login(state, user) {
    state.user = user;
  },
  setAuthProvider(state, provider) {
    state.authProvider = provider;
    localStorage.setItem('authProvider', provider);
  },
  setMicrosoftIdToken(state, token) {
    state.microsoftIdToken = token;
    localStorage.setItem('microsoftIdToken', token);
  },
  logout(state) {
    state.user = null;
    state.permissions = [];
    state.authProvider = null;
    state.microsoftIdToken = null;
    localStorage.removeItem('authProvider');
    localStorage.removeItem('microsoftIdToken');
  },
  permissions(state, permissions) {
    state.permissions = permissions;
  },
};

const actions = {
  async initialize({ dispatch, commit }) {
    const { data } = await dispatch(
      'post',
      { action: '/session' },
      { root: true }
    );
    if (data) {
      await dispatch('permissions', { user: data });
      commit('login', data);
      if (localStorage.getItem('page')) {
        const { name, params } = JSON.parse(localStorage.getItem('page'));
        return router.push({ name, params });
      }
      router.push({ name: 'dashboard' });
    }
  },
  async login({ commit, dispatch }, { formData }) {
    const { data, message } = await dispatch(
      'post',
      { action: '/login', formData },
      { root: true }
    );
    if (data) {
      await dispatch('permissions', { user: data });
      commit('login', data);
      router.push({ name: 'dashboard' });
      return { data, message };
    }
  },
  async microsoftSsoAuthentication({ commit, dispatch }, { formData }) {
    const response = await dispatch(
      'post',
      { action: '/microsoft', formData },
      { root: true }
    );
    if (response?.data) {
      await dispatch('permissions', { user: response.data });
      commit('login', response.data);
      commit('setAuthProvider', 'microsoft');
      if (response.idToken) {
        commit('setMicrosoftIdToken', response.idToken);
      }
      router.push({ name: 'dashboard' });
      return { data: response.data, message: response.message };
    }
  },
  async register({ dispatch }, { formData }) {
    const { message } = await dispatch(
      'post',
      { action: '/register', formData },
      { root: true }
    );
    if (message) {
      router.push({ name: 'login' });
    }
  },
  async proxy({ dispatch, commit }, { formData = {}, method = 'post' }) {
    const { data, message } = await dispatch(
      method,
      { action: '/proxy', formData },
      { root: true }
    );
    if (data && message) {
      await dispatch('permissions', { user: data });
      commit('login', data);
      return { data, message };
    }
  },
  async logout({ dispatch, state }) {
    const authProvider = state.authProvider;
    const idToken = state.microsoftIdToken;

    const { message } = await dispatch(
      'post',
      { action: '/logout' },
      { root: true }
    );
    if (message) {
      dispatch('logoutWithoutAction');

      if (authProvider === 'microsoft' && idToken) {
        const payload = JSON.parse(atob(idToken.split('.')[1]));
        const params = new URLSearchParams({
          post_logout_redirect_uri: window.location.origin,
          id_token_hint: idToken,
        });
        window.location.href = `https://login.microsoftonline.com/${payload.tid}/oauth2/v2.0/logout?${params.toString()}`;
      } else {
        router.push({ name: 'login' });
      }
    }
  },
  logoutWithoutAction({ commit }) {
    commit('logout');
    localStorage.removeItem('page');
  },
  forgotPassword({ dispatch }, { formData }) {
    return dispatch(
      'post',
      { action: '/forgot-password', formData },
      { root: true }
    );
  },
  resetPassword({ dispatch }, { formData }) {
    return dispatch(
      'post',
      { action: '/reset-password', formData },
      { root: true }
    );
  },
  updatePassword({ dispatch }, { formData }) {
    return dispatch(
      'put',
      { action: '/update-password', formData },
      { root: true }
    );
  },
  async permissions({ commit, dispatch }, { user }) {
    const { data } = await dispatch(
      'get',
      { action: `/permissions/role/${user.roleId}` },
      { root: true }
    );
    if (data) {
      commit('permissions', data);
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
